import { Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import { Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../api.service';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-home',
  templateUrl: './career.component.html',
  styleUrls: ['./career.component.css']
})
export class CareerComponent implements OnInit {

  @ViewChild('fileInput') fileInput: ElementRef;
  form: FormGroup;
  public sliders: any[] = [];
  base64File: string;
  fileExtension: string;

  constructor(
    private route: Router,
    private viewportScroller: ViewportScroller,
    private titleService: Title,
    private metaService: Meta,
    private httpClient: HttpClient,
    private apiService: ApiService,
    private formBuilder: FormBuilder

  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      driverName: ['', Validators.required],
      driverEmail: ['', [Validators.required, Validators.email]],
      driverPhone: ['', Validators.required],
      driverFile: [null, Validators.required]
    });

    this.titleService.setTitle("Career | Line Haul")

    const metaDesc = this.metaService.getTag('name=description');

    if(!metaDesc){
        this.metaService.addTags([
            {name: "description", content: "Linehaul is an organization lead by a team of highly enthusiastic individuals whom are committed, innovative and passionate in continuously adding value to our business industry. Our Vision is to be the market leader in logistic innovation, providing execution efficiency and accessibility to our customers, henceforth, carrying the Mission to constantly increase our value proposition in the context of secured, price competitiveness and haulage excellence. The company organization structure is helmed by 4 key departments in which, are supervised by industry captains whom will navigate the operation towards business excellence. The mentioned departments are Operation Excellence, Commercial (Sales & Marketing), Information System & Technology, (IS&T), Strategic Planning and Finance. In Linehaul, our team is committed and motivated towards product innovation to cater for different market segments and its demand, hence investing extensively in logistic Research & Development initiatives to sustain market dynamics and maintain our competitive advantages. Begin your business journey with us, your entrusted Logistic Partner!"}
        ]);
    }else{
        this.metaService.updateTag(
            {name: "description", content: "Linehaul is an organization lead by a team of highly enthusiastic individuals whom are committed, innovative and passionate in continuously adding value to our business industry. Our Vision is to be the market leader in logistic innovation, providing execution efficiency and accessibility to our customers, henceforth, carrying the Mission to constantly increase our value proposition in the context of secured, price competitiveness and haulage excellence. The company organization structure is helmed by 4 key departments in which, are supervised by industry captains whom will navigate the operation towards business excellence. The mentioned departments are Operation Excellence, Commercial (Sales & Marketing), Information System & Technology, (IS&T), Strategic Planning and Finance. In Linehaul, our team is committed and motivated towards product innovation to cater for different market segments and its demand, hence investing extensively in logistic Research & Development initiatives to sustain market dynamics and maintain our competitive advantages. Begin your business journey with us, your entrusted Logistic Partner!" },
            "name=description"
        )
    }
    this.loadCarousel('career', 'active');

  }

  loadCarousel(page: string, state: string): void {
    this.apiService.loadCarousel(page, state).subscribe(
        response => {
            this.sliders = response.carousels;
        },
        error => {
            console.error('Error fetching carousel:', error);
        }
    );
  }

    // To handle Driver form -------->
    submitted = false;

    submitForm() {
      this.submitted = true;

      if (this.form.valid) {
        this.sendMail();
      }
    }

    sendMail() {
      console.log('Form values:', this.form.value);

      if (this.form.valid && this.base64File && this.fileExtension) {
        const data = {
          name: this.form.value.driverName,
          email: this.form.value.driverEmail,
          phone: this.form.value.driverPhone,
          file: this.base64File,
          fileExtension: this.fileExtension,
          form_type: 'driver'
        };

        console.log('Data to be sent:', data);

        this.apiService.postSendEmail(data).subscribe(
          (res: any) => {
            console.log('Email sent successfully', res);
            Swal.fire(
              'Sent.',
              'We will contact you later, Thanks!',
              'success'
          )
          },
          error => {
            console.error('Error sending email', error);
          }
        );
      }
    }

    selectedFile: File | null = null;

  onFileChange(event: any) {
    const fileInput = event.target;
    if (fileInput.files && fileInput.files.length > 0) {
      const file = fileInput.files[0];
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result?.toString().split(',')[1];
        if (base64String) {
          this.base64File = base64String;
        }
      };

      reader.readAsDataURL(file);

      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      if (fileExtension) {
        this.fileExtension = fileExtension;
      }
    }
  }


  goToPremium(){
    window.open('https://linehaul.com.my/assets/image/Icons/premium.jpg', '_blank');
  }

  goToExpress(){
    window.open('https://linehaul.com.my/assets/image/Icons/express.jpg', '_blank');
  }


  public onClick(elementId: string): void {

    this.viewportScroller.scrollToAnchor(elementId);

    //   window.location.href = '/v2/landing#AnchorId';
  }

  public goToFragment(fragment: string): void{

    // let elementId = 'serviceId'

    // this.route.navigate( ['/landing#'], {fragment: fragment});
    // this.route.navigate(['/landing#'], { fragment: 'serviceId' });
    // this.route.navigate(['/landing#'+fragment])
    // this.redirectTo('/landing#serviceId');
    // window.location.href = '/v2/landing#' + fragment;
    // window.location.href = '/landing#' + fragment;
    // window.location.href = 'https://lineclearexpress.com/v2/landing#serviceId'
    // window.location.replace("http://someUrl.com");
    // this.viewportScroller.scrollToAnchor(elementId);

    // production
    // this.route.navigateByUrl("/v2/landing#serviceId")

    // staging
    this.route.navigateByUrl("/#serviceId")

  }

  goToAboutUs(){
    this.route.navigate(['about-us']);
  }

  goToOurStrength(){
    this.route.navigate(['our_strength']);
  }

  goToHome(){
    this.route.navigate(['home']);
  }

  goToMilestone(){
    this.route.navigate(['milestone']);
  }

  goToWhyUs(){
    this.route.navigate(['why_us']);
  }

  goToDriver(){
    this.route.navigate(['driver']);
  }


}

